module.exports = __webpack_public_path__ + "img/trophy-1.970565a.svg";